import { StrictMode, Suspense } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import { Loading } from "src/components";
import { CacheErrorBoundary } from "src/components/root/CacheErrorBoundary";

import App from "./App";
import "./setupWorkers";
import "./utilities/initialSetup";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <CacheErrorBoundary>
      <Suspense fallback={<Loading name="Root - Suspense" />}>
        <RouterProvider router={App} />
      </Suspense>
    </CacheErrorBoundary>
  </StrictMode>
);
